import type {
  ApiContext,
  ApiReturnFrontendPermission,
} from '@highimpact-frontend/api-types';
import { createContext, useContext, type ReactNode } from 'react';

export type FetchFrontendPermission = (
  params: ApiContext,
  signal: AbortSignal
) => Promise<ApiReturnFrontendPermission>;

const PermissionFetchContext = createContext<FetchFrontendPermission | null>(
  null
);

export function PermissionFetchProvider({
  fetchPermission,
  children,
}: {
  fetchPermission: FetchFrontendPermission;
  children: ReactNode;
}) {
  return (
    <PermissionFetchContext.Provider value={fetchPermission}>
      {children}
    </PermissionFetchContext.Provider>
  );
}

export function usePermissionFetch(): FetchFrontendPermission | null {
  return useContext(PermissionFetchContext);
}
